/*
 * This file is part of glowingblue/newvigation.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import classList from 'flarum/common/utils/classList';
import icon from 'flarum/common/helpers/icon';
import Link from 'flarum/common/components/Link';
import SelectDropdown from 'flarum/common/components/SelectDropdown';
import ItemList from 'flarum/common/utils/ItemList';
import * as terms from '@fof-terms';
import { slug } from '../../common';

// Make translation calls shorter
const t = app.translator.trans.bind(app.translator);
const prfx = `${slug}.forum.index_page`;

export default class IndexPageHero extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	get classNames() {
		const { currentTag } = this.attrs;
		let color;
		if (currentTag) {
			color = currentTag.color();
		}

		return classList({
			IndexPageHero: true,
			Hero: true,
			IndexPageTagHero: !!currentTag,
			'TagHero--colored': !!color,
		});
	}

	get wrapperClasses() {
		const { currentTag } = this.attrs;

		return classList({
			'IndexPageHero--wrapper': true,
			'IndexPageTagHero--wrapper': !!currentTag,
		});
	}

	oncreate(vnode) {
		super.oncreate(vnode);

		// Add the sub-tag name as data-attr to the currently selected item of the SelectDropdown
		const { currentTag } = this.attrs;
		if (currentTag && currentTag.parent()) {
			this.$('.Dropdown-toggle .Button-label').attr('data-sub-tag', ` (${currentTag.name()})`);
		}
	}

	get title() {
		return this.attrs.title || t('core.forum.index.all_discussions_link');
	}

	get icon() {
		return this.attrs.icon || 'far fa-comments';
	}

	get dropdownDefaultLabel() {
		return t(`${prfx}.hero.dropdown_label`);
	}

	get href() {
		return this.attrs.href || app.route('index', app.search.stickyParams());
	}

	view() {
		let color;
		if (this.attrs.currentTag) {
			color = this.attrs.currentTag.color();
		}

		return (
			<div className={this.wrapperClasses}>
				{this.updateAlert}
				<header className={this.classNames} style={color ? { backgroundColor: color } : ''}>
					<div className="container">
						<div className="containerNarrow">{this.items().toArray()}</div>
					</div>
				</header>
			</div>
		);
	}

	get updateAlert() {
		if (app.initializers.has('fof-terms')) {
			const UpdateAlert = terms.components.UpdateAlert;
			return <UpdateAlert />;
		}

		return null;
	}

	items() {
		const items = new ItemList();

		const { navItems, currentTag } = this.attrs;

		items.add(
			'title',
			<h1 className="Hero-title">
				{currentTag ? (
					<Link href={this.href}>
						{icon(this.icon)} {this.title}
					</Link>
				) : (
					[icon(this.icon), ' ', this.title]
				)}
			</h1>,
			50
		);

		if (navItems) {
			items.add(
				'tagSelect',
				<SelectDropdown buttonClassName="Button" defaultLabel={this.dropdownDefaultLabel} caretIcon="fas fa-chevron-down">
					{navItems.toArray()}
				</SelectDropdown>,
				30
			);
		}

		if (currentTag) {
			items.add('subtitle', <div className="Hero-subtitle">{currentTag.description()}</div>, 10);
		}

		return items;
	}
}
